import type { SiteInfo } from "@/types";
import siteIcon from "../assets/site-icon.jpg";
import { MOCK_GOOGLE_LOGIN_PATH } from "../session";

/**
 * SSO 를 켠 사이트로 둔다 — 로그인 화면의 Google 버튼까지 보이게. 누르면 dev 서버가
 * mock 계정으로 로그인시킨다(vite.config.ts 의 mockApi). 비밀번호 로그인도 그대로 된다.
 */
export const site: SiteInfo = {
  site_key: "local",
  display_name: "WORKTHINGS (mock)",
  icon_url: siteIcon,
  sso_configured: true,
  login_url: MOCK_GOOGLE_LOGIN_PATH,
  prompt_version: "mock",
};
